import { ValidationModel } from '../../../shared/models/validation-results/validation.model';

export class DisbursementDigitalRequestModel extends ValidationModel {

    // Gets or sets the id
    public id: number;

    // Gets or sets the finance disbursement request identifier.
    public financeDisbursementRequestId: number;

    // Gets or sets the merchant identifier.
    public merchantId: number;

    // Gets or sets the order number
    public orderNumber: number;

    // Gets or sets the amount.
    public amount: number;

    // Gets or sets the authorization code
    public authorizationCode: string;

    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json) {
            this.id = json.id;
            this.financeDisbursementRequestId = json.financeDisbursementRequestId;
            this.merchantId = json.merchantId;
            this.orderNumber = json.orderNumber;
            this.amount = json.amount;
            this.authorizationCode = json.authorizationCode;
        }
    }
}
